import { fmtDateIST, fmtTimeIST } from '@/lib/format';

export const formatDateRange = (start, end) => {
  try {
    const dateStr = fmtDateIST(start, { weekday: 'short', month: 'short', day: 'numeric' }, '');
    const startStr = fmtTimeIST(start, { hour: 'numeric', minute: '2-digit' }, '');
    const endStr = fmtTimeIST(end, { hour: 'numeric', minute: '2-digit' }, '');
    return `${dateStr} · ${startStr} – ${endStr}`;
  } catch {
    return `${start} – ${end}`;
  }
};

export const splitEmails = (raw) =>
  (raw || '')
    .split(/[,;\n\r\s]+/)
    .map((s) => s.trim())
    .filter(Boolean);

export const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

export const emailsEqual = (a, b) => (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase();

export const panelOverlapsCandidate = (panelEmails, candidateEmail) =>
  !!candidateEmail && panelEmails.some((e) => emailsEqual(e, candidateEmail));

// datetime-local expects local wall clock, not UTC from toISOString().
export const toDatetimeLocalValue = (d) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** True when a datetime-local value is before the current minute (picker has no seconds). */
export const isDatetimeLocalInPast = (value) => {
  if (!value) return false;
  const selected = new Date(value);
  if (Number.isNaN(selected.getTime())) return false;
  const now = new Date();
  now.setSeconds(0, 0);
  return selected < now;
};

const MIN_MANUAL_DURATION_SEC = 1;

/** Whole seconds from a minutes field; null when empty or invalid. */
export const minutesToDurationSec = (raw) => {
  const n = Number(String(raw ?? '').trim());
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.max(MIN_MANUAL_DURATION_SEC, Math.round(n * 60));
};

export const clampDurationSec = (sec) => {
  const n = Number(sec);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.max(MIN_MANUAL_DURATION_SEC, Math.round(n));
};

/** Read media duration from a video File (browser metadata). */
export const readVideoDurationSec = (file) => new Promise((resolve, reject) => {
  if (!file) {
    reject(new Error('No file'));
    return;
  }
  const url = URL.createObjectURL(file);
  const video = document.createElement('video');
  video.preload = 'metadata';
  const cleanup = () => {
    video.removeAttribute('src');
    video.load();
    URL.revokeObjectURL(url);
  };
  video.onloadedmetadata = () => {
    const sec = clampDurationSec(video.duration);
    cleanup();
    if (sec == null) reject(new Error('Could not read video duration'));
    else resolve(sec);
  };
  video.onerror = () => {
    cleanup();
    reject(new Error('Could not read video duration'));
  };
  video.src = url;
});
